import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterBestaetigen() {
  const { token } = useParams();
  const [status, setStatus] = useState("loading"); // loading | ok | already | error
  const [email, setEmail] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/newsletter/confirm/${token}`);
        setEmail(res.data?.email || "");
        setStatus(res.data?.status === "already_confirmed" ? "already" : "ok");
      } catch {
        setStatus("error");
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#FAFAF7] flex items-center justify-center px-6">
      <div className="max-w-lg w-full bg-white border border-[#E3DECE] p-8 md:p-12 text-center" data-testid="newsletter-confirm-page">
        {status === "loading" && (
          <>
            <Loader2 size={40} className="mx-auto animate-spin text-[#BA6D52]" />
            <p className="mt-6 text-sm text-[#757067]">Ihre Anmeldung wird bestätigt …</p>
          </>
        )}
        {status === "ok" && (
          <>
            <CheckCircle2 size={56} className="mx-auto text-emerald-600" />
            <h1 className="font-serif text-3xl md:text-4xl font-light tracking-tighter mt-6 text-[#2C2A26]">
              Anmeldung bestätigt
            </h1>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Vielen Dank! <b>{email}</b> ist ab jetzt für gelegentliche Neuigkeiten und Angebote von Lukas Stutz — Mietkoch für Gastronomie &amp; Events eingetragen.
            </p>
          </>
        )}
        {status === "already" && (
          <>
            <CheckCircle2 size={56} className="mx-auto text-emerald-600" />
            <h1 className="font-serif text-3xl md:text-4xl font-light tracking-tighter mt-6 text-[#2C2A26]">
              Bereits bestätigt
            </h1>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Die Adresse <b>{email}</b> ist bereits für den Newsletter angemeldet — Sie müssen nichts weiter tun.
            </p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle size={56} className="mx-auto text-red-500" />
            <h1 className="font-serif text-3xl md:text-4xl font-light tracking-tighter mt-6 text-[#2C2A26]">
              Link ungültig
            </h1>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Dieser Bestätigungslink ist ungültig oder abgelaufen. Bitte melden Sie sich erneut über das Anfrage-Formular an.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="newsletter-back-home"
          className="mt-10 inline-block text-xs uppercase tracking-[0.25em] text-[#BA6D52] hover:text-[#9E5841] underline"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
